export default {
  search_placeholder: "搜尋常見問題...",
  no_results_title: "未找到結果",
  no_results_subtitle: "嘗試調整搜尋詞語或瀏覽左側分類。",
  search_cleared_message: "已清除搜尋以顯示完整內容",
  still_have_questions: {
    before_email: "還有疑問嗎？請聯絡我們 ",
    after_email: " — 我們的團隊將在 24 小時內回覆。",
  },
};
